// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"ArticleRating_buttonWrapper__1Nz4A","inputWrapper":"ArticleRating_inputWrapper___lJrt"};